import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "none",
    padding: "0px",
    minWidth: "90%",
    maxWidth: "90%",
  },
};

function PurchanseOrder() {
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [text, setText] = useState(''); 
  const [value] = useDebounce(text, 1000);

  // const [orderList, setOrderList] = useState([]);
// const [text, setText] = useState('');
// const [value] = useDebounce(text, 500);
const [page, setPage] = useState(1);
const [hasMore, setHasMore] = useState(true);
// const [isLoadingOn, setIsLoadingOn] = useState(false);


  async function getPurchaseOrder({ page = 1, pageSize = 20, vendorName = "", search = "", isLoadMore = false }) {
    setIsLoadingOn(true);
  
    // Construct query params dynamically
    const params = new URLSearchParams();
    // if (vendorName) params.append("vendorName", vendorName);
    if (search) params.append("search", search);
    // if (purchaseOrder) params.append("purchaseOrder", purchaseOrder);
    params.append("page", page);
    params.append("pageSize", pageSize);
  
    const tempData = await getData(`inventory/getPurchaseOrder?${params.toString()}`);
    setIsLoadingOn(false);
  
    if (tempData?.statusCode === 200) {
      const records = tempData?.data?.records || [];
  
      setOrderList(prev => {
        if (isLoadMore) {
          return [...prev, ...records]; // Append for infinite scroll
        } else {
          return records; // Reset list for new search or first load
        }
      });
  
      return {
        hasMore: records.length === pageSize,
      };
    } else {
      setOrderList([]);
      Swal.fire({
        title: "Error!",
        text: tempData?.data?.errors?.msg || "Something went wrong!!!",
      });
      return { hasMore: false };
    }
  }
  


  // useEffect(() => {
  //   // Initial load - fetch all purchase orders
  //   getPurchaseOrder('');
  // }, []);

  useEffect(() => {
    setIsSearching(value !== ''); // set true if searching
    getPurchaseOrder(value);      // fetch data based on debounced value
  }, [value]);

  useEffect(() => {
    setPage(1);
    getPurchaseOrder({ page: 1, search: value });
  }, [value]);

  const filterPurchaseOrder = (e) => {
    setText(e.target.value);
  }

  useEffect(() => {
    const handleScroll = () => {
      const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;
  
      if (bottom && hasMore && !isLoadingOn) {
        const nextPage = page + 1;
        setPage(nextPage);
        getPurchaseOrder({ page: nextPage, search: value, isLoadMore: true });
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [page, hasMore, value, isLoadingOn]);


  return (
    <div className="purchaseOrderSec purchaseListSec">
      <div>
        {isLoadingOn ? <Loader /> : ""}

        {/* {Array.isArray(orderList) && orderList.length > 0 && ( */}
          <div className="filter mb-3">
            <div className="row">
              <div className="col-sm-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Vender Name"
                  // onChange={(e) => filterPurchaseOrder(e)}
                  onChange={(e) => setText(e.target.value)}

                />
              </div>
            </div>
          </div>
        {/* )} */}
        <div className="d-flex justify-content-between align-items-center">
          <h4>All Purchase Orders</h4>
          <div>
            {/* <button className="btn btn-outline-primary transitbtnbg">In Transit Receives</button> */}
            <Link to={'purchase/new'}><button className="btn btn-primary mx-2">
              + New
            </button>
            </Link>
            {/* <button className="btn btn-light">⋮</button> */}
          </div>
        </div>
        {Array.isArray(orderList) && orderList.length === 0 ? (
          isSearching ? (
            <div className="text-center my-5">
              <h5>No data available.</h5>
            </div>
          ) : (
            <div className="">
              <div className="text-center my-3 centercontentSec">
                <h3>Start Managing Your Purchase Activities!</h3>
                <p className="subcont">Create, customize, and send professional Purchase Orders to your vendors.</p>
                <Link to="/purchase/new">
                  <button className="btn btn-primary createnewPurchase">CREATE NEW PURCHASE ORDER</button>
                </Link>
              </div>

              <div className="purchasebtmsec">
                <h5 className="text-center">Life cycle of a Purchase Order</h5>
                <div className="d-flex justify-content-center my-5 worlflowimgsec">
                  <img src="../assets/img/purchaseOrder-workflow.png" alt="Workflow" className="img-fluid" />
                </div>

                <div className="mt-4 row workflow-block">
                  <div className="col-lg-9 offset-lg-3">
                    <h6>In the Purchase Orders module, you can:</h6>
                    <ul>
                      <li>Create and send a purchase order to your vendors when you are in need of a product.</li>
                      <li>Convert the purchase order into a bill after you receive an invoice for your purchase.</li>
                      <li>Set conditions that determine when a purchase order is marked as closed.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="purchaseorderTable">
            <div className="table-container">
              <div className="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }} className="checkbox-cell"><input type="checkbox" /></th>
                      <th style={{ width: "200px" }}>DATE</th>
                      <th style={{ width: "300px" }}>PURCHASE ORDER#</th>
                      <th style={{ width: "200px" }}>REFERENCE</th>
                      <th style={{ width: "300px" }}>VENDOR NAME</th>
                      <th style={{ width: "200px" }}>STATUS</th>
                      <th style={{ width: "300px" }}>RECEIVED</th>
                      <th style={{ width: "300px" }}>BILLED</th>
                      <th style={{ width: "200px" }}>AMOUNT</th>
                      <th style={{ width: "300px" }}>DELIVERY DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderList.map((item, index) => (
                      <tr key={index} className="table-row">
                        <td className="checkbox-cell"><input type="checkbox" /></td>
                        <td>{item?.date}</td>
                        <td>
                          <Link to={`/purchaseorderDetails/${item?.purchaseOrderId}`} className="vendor-name">
                            {item?.purchaseOrder}
                          </Link>
                        </td>
                        <td>{item?.reference}</td>
                        <td>{item?.vendorName}</td>
                        <td>{item?.statusName}</td>
                        <td>{item?.received}</td>
                        <td>{item?.billed}</td>
                        <td>{item?.orderTotal}</td>
                        <td>{item?.deliveryDate}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}


      </div>
    </div>
  );
}

export default PurchanseOrder;
